<template>
  <div class="app-container">
    <basic-container>
      <div class="operation">
        <div v-if="!isEdit">
          <el-button @click="cancel" size="medium">取消</el-button>
          <el-button size="medium" type="primary" @click="onSubmit()">保存</el-button>
        </div>
        <div v-else>
          <el-button @click="cancel" size="medium">取消</el-button>
          <el-button size="medium" type="primary" @click="onEditSubmit()">保存</el-button>
        </div>
      </div>
      <el-form ref="paperForm" class="sizeForm" :model="paperForm" label-width="100px" size="medium" :rules="rules">
        <el-row>
          <el-col >
            <el-form-item label="试卷名称" prop="title">
              <el-input v-model="paperForm.title"  placeholder="请输入试卷名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item label="试卷类型" prop="type">
              <el-select class="paper-list-filter-value" placeholder="类型" v-model="paperForm.type" clearable size="small">
                  <el-option
                    v-for="item in paperTypeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="18">
            <el-form-item label="试卷使用权限" prop="title">
              <el-input v-model="paperForm.title"  placeholder="请输入题库名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </basic-container>
    <choice-subject ref="choiceSubject" v-if="paperForm.type === paperTypeMap.fixed"  :subjects="subjects"/>
  </div>
</template>
<script>
import { createPaper, editPaper, getPaperDetail } from '@/api/app/paper'
import { paperTypeOption, paperTypeMap } from '@/const/crud/app/paper'
import choiceSubject from './components/choice-subject.vue'

export default {
  components: {
    choiceSubject
  },
  data() {
    return {
      paperTypeOption,
      paperTypeMap,
      paperForm: {
        title: '',
        type: paperTypeMap.fixed
      },
      subjects: [],
      totalScore: 0,
      id: '',
      paperId: '',
      isEdit: false,
      rules: {
        title: [
          { type: 'string', required: true, message: '请输入试卷名称', trigger: 'blur' },
          { max: 256, message: '不超过256个', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选泽试卷类型', trigger: 'change' },
        ]
      }
    };
  },
  created() {
  },
  mounted() {
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },
  methods: {
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    vaildParams(params) {
      let isSuccess = true;
      try {
        params.subjects.forEach(item => {
          if (!item.score) {
            isSuccess = false
            throw new Error('题目分值不能为空');
          }
        });
      } catch (error) {
        this.$message({
          message: '题目分值不能为空或0分',
          type: 'error'
        })
      }
      return isSuccess;
    },
    onSubmit() {
      const params = {
        prototypeDTO: {
          title: this.paperForm.title,
          totalScore: this.$refs.choiceSubject.totalScore,
          type: this.paperForm.type
        },
        subjects: this.$refs.choiceSubject.subjectChoiceList
      }
      this.$refs.paperForm.validate((valid) => {
        if (valid) {
          if (this.vaildParams(params)) {
            createPaper(params).then(res => {
              if (res.data.code === 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                })
                this.cancel();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
              }
            }).catch(err => {
              this.$message({
                message: err,
                type: 'error'
              })
            })
          }
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    getDetail() {
      getPaperDetail(this.id).then(res => {
        this.paperForm = {
          title: res.data.data.title,
          totalScore: res.data.data.totalScore,
          type: res.data.data.type
        };
        this.paperId = res.data.data.paper.id
        this.subjects =  res.data.data.paper.subjectRelations;
      }).catch(error => {
        this.$message({
          message: '获取试卷详情失败',
          type: 'error'
        })
      })
    },
    onEditSubmit() {
      const params = {
        prototypeDTO: {
          id: this.id,
          title: this.paperForm.title,
          totalScore: this.$refs.choiceSubject.totalScore,
          type: this.paperForm.type
        },
        subjects: this.$refs.choiceSubject.subjectChoiceList,
        id: this.paperId,
      }
      this.$refs.paperForm.validate((valid) => {
        if (valid) {
          if (this.vaildParams(params)) {
            editPaper(params).then(res => {
              if (res.data.code === 0) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                })
                this.cancel();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
              }
            }).catch(err => {
              this.$message({
                message: err,
                type: 'error'
              })
            })
          }
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .operation {
    text-align: right;
  }
  .sizeForm{
    width: 650px;
  }
</style>
